
import { Component, Prop, mixins } from 'nuxt-property-decorator'
import Mixin from '@/mixins'

@Component({
  name: 'FAQ',
})
export default class FAQ extends mixins(Mixin) {
  @Prop({ required: true }) readonly questions: any
  @Prop({ required: true }) readonly company: any

  activeQuestionIndex = -1

  get activeQuestions() {
    return this.questions?.filter((item: any) => item.active == 1)
  }

  handleClickQuestion(index: any) {
    if (index === this.activeQuestionIndex) {
      this.activeQuestionIndex = -1
    } else {
      this.activeQuestionIndex = index
    }
  }
}
